var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "details-view tab-approval-matters",
      staticStyle: { height: "600px !important" }
    },
    [
      _c(
        "cargo-left-right-resize",
        {
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "90%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" }
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("cargo-ag-grid", {
                staticClass: "section",
                attrs: {
                  "grid-options": _vm.leftGridOptions,
                  "row-data": _vm.leftRowData,
                  "show-side-bar": false,
                  "min-height": "100%",
                  "grid-style": "min-width: 240px;width:100%;height:100%;"
                },
                on: {
                  gridReady: function(p) {
                    _vm.gridApi = p.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c(
              "div",
              { staticClass: "main-content" },
              [
                _c("div", { staticClass: "operations" }, [
                  _c(
                    "div",
                    { staticStyle: { margin: "6px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { no: "refresh", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.fetchData(true)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "moreFilter", type: "primary" },
                          on: { click: _vm.moreFilter }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MoreFilters")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showDealBtn,
                              expression: "showDealBtn"
                            }
                          ],
                          attrs: { no: "handled", type: "success" },
                          on: {
                            click: function($event) {
                              _vm.batchApprove(
                                _vm.$t("CargoMsg.Cargo_Agree"),
                                7001
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Agree")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showDealBtn,
                              expression: "showDealBtn"
                            }
                          ],
                          attrs: { no: "ignoreMessage", type: "danger" },
                          on: {
                            click: function($event) {
                              _vm.batchApprove(
                                _vm.$t("CargoMsg.Cargo_Refuse"),
                                7002
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refuse")))]
                      )
                    ],
                    1
                  )
                ]),
                _c("approval-list-grid", {
                  key: _vm.gridKey,
                  ref: "approvalListGrid",
                  attrs: {
                    "config-module": "23030702",
                    type: _vm.type,
                    "document-config-id-prop": _vm.documentConfigId,
                    "per-config-name": _vm.perConfigName,
                    "grid-refresh-id": _vm.gridRefreshId,
                    total: _vm.filter.total,
                    status: _vm.status,
                    "row-data": _vm.rowData,
                    dynamics: true
                  },
                  on: {
                    toQuery: _vm.toQuery,
                    changeSelected: _vm.changeSelected
                  }
                })
              ],
              1
            )
          ])
        ],
        2
      ),
      _c("more-approval-filter-dialog", {
        attrs: {
          visible: _vm.filterDialog.visible,
          filter: _vm.filter,
          type: _vm.type,
          "document-config-id": _vm.documentConfigId,
          "per-config-name-prop": _vm.perConfigName,
          "grid-refresh-id-prop": _vm.gridRefreshId
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.filterDialog, "visible", $event)
          },
          "update:perConfigNameProp": function($event) {
            _vm.perConfigName = $event
          },
          "update:per-config-name-prop": function($event) {
            _vm.perConfigName = $event
          },
          "update:gridRefreshIdProp": function($event) {
            _vm.gridRefreshId = $event
          },
          "update:grid-refresh-id-prop": function($event) {
            _vm.gridRefreshId = $event
          },
          toQuery: _vm.toQuery,
          close: function($event) {
            _vm.filterDialog.visible = false
          }
        }
      }),
      _c("batch-submit-or-approve-dialog", {
        attrs: {
          visible: _vm.batchSubmitOrApproveDialog.visible,
          "row-data": _vm.batchSubmitOrApproveDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchSubmitOrApproveDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }